import { RollStatusTag } from "@/pages/catalogs/shared/components/RollStatusTag";
import { Autocomplete, Box, TextField } from "@mui/material";
import { FieldError } from "react-hook-form";

export const rollStatusCodes = [
	{
		Code: "B",
		Name: "Blank",
		Color: "#eeeeee",
		TextColor: "#1F2937",
		isPickable: true,
		order: 1,
	},
	{
		Code: "P",
		Name: "In Process",
		Color: "#fad215",
		TextColor: "#FFFFFF",
		isPickable: true,
		order: 2,
	},
	{
		Code: "R",
		Name: "Ready",
		Color: "#009460",
		TextColor: "#FFFFFF",
		isPickable: true,
		order: 3,
	},
	{
		Code: "D",
		Name: "Damaged",
		Color: "#ce2029",
		TextColor: "#FFFFFF",
		isPickable: true,
		order: 8,
	},
	{
		Code: "K",
		Name: "Broken",
		Color: "#eeeeee",
		TextColor: "#1F2937",
		isPickable: true,
		order: 9,
	},

	// Rollset status
	{
		Code: "A",
		Name: "Build in Progress",
		Color: "#EA580C",
		TextColor: "#FFFFFF",
		isPickable: false,
		order: 4,
	},
	{
		Code: "C",
		Name: "Completed",
		Color: "#2563EB",
		TextColor: "#FFFFFF",
		isPickable: false,
		order: 5,
	},
	{
		Code: "S",
		Name: "Signed Off",
		Color: "#9333EA",
		TextColor: "#FFFFFF",
		isPickable: false,
		order: 6,
	},
	{
		Code: "I",
		Name: "Installed",
		Color: "#1F2937",
		TextColor: "#FFFFFF",
		isPickable: false,
		order: 7,
	},
];

type Props = {
	label: string;
	value: string | null;
	onChange?: Function;
	fieldError?: FieldError | undefined;
	disabled?: boolean;
	required?: boolean;
};

export const RollStatusSelector = ({
	label,
	value,
	onChange = () => {},
	fieldError,
	disabled = false,
	required = false,
}: Props) => {
	const selectedType =
		rollStatusCodes.find((code) => code.Code === value) || null;

	return (
		<Autocomplete
			id="roll-status-selector"
			clearOnEscape
			autoHighlight
			options={rollStatusCodes}
			getOptionDisabled={(option) => !option.isPickable}
			getOptionLabel={(option) => option.Name}
			renderOption={(props, option) => (
				<Box
					{...props}
					component="li"
					sx={{
						display: "flex",
						alignItems: "center",
					}}
				>
					<Box
						component="span"
						style={{
							width: "25px",
							height: "25px",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							marginRight: "8px",
							marginLeft: "8px",
						}}
					>
						<RollStatusTag
							status={{
								Code: option.Code,
								Name: option.Name,
							}}
						/>
					</Box>
					{option.Name}
				</Box>
			)}
			renderInput={(params) => (
				<TextField
					{...params}
					required={required}
					label={label}
					variant="outlined"
					fullWidth
					error={!!fieldError}
					helperText={fieldError?.message}
					size="small"
					inputProps={{
						...params.inputProps,
						"data-test-id": "roll-status-selector",
					}}
					InputProps={{
						...params.InputProps,
						startAdornment: value ? (
							<span
								style={{
									width: "25px",
									height: "25px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									marginRight: "8px",
									marginLeft: "8px",
								}}
							>
								<RollStatusTag
									status={{
										Code: selectedType?.Code ?? "",
										Name: selectedType?.Name ?? "",
									}}
								/>
							</span>
						) : null,
					}}
				/>
			)}
			value={selectedType}
			onChange={(event, newValue) => {
				onChange(newValue?.Code ?? null);
			}}
			disabled={disabled}
		/>
	);
};
